import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import './ContenidoPlan.scss';
import ConceptoItemResumen from './ConceptoItemResumen';
import * as moment from 'moment';
import { number } from 'yup';

const ContenidoPlan = ({ plan = {}, setConceptosFinales, conceptosFinales, handleEditarConcepto, fecha_inicio_p, discente_trabajador }) => {
  const { dt_plan: conceptos = [], plan: planes = [], id_tp_modalidad } = plan;
  const [modalidad, setModalidad] = useState(null);
  const num_romanos = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];
  const mostarItems = () => {
    if (planes.length > 1 && !discente_trabajador) return <Alert variant='danger'>
      El discente tiene mas de un plan asignado para este producto
    </Alert>
    else if (planes.length == 0 && !discente_trabajador) return <Alert variant='danger'>
      El discente no tiene planes asignados para este producto
    </Alert>
    else if (!conceptos.length) {
      return <Alert variant='danger'>
        No hay contenido en este plan
      </Alert>
    } else {
      return (
        <>
          {planes.length == 1 && (
            <Alert variant='info'>
              {planes[0].nombre_plan}
            </Alert>
          )}
          {[...conceptosFinales].map((concepto, index) => (
            <ConceptoItemResumen
              key={index}
              handleEditarConcepto={handleEditarConcepto}
              idModalidad={modalidad}
              concepto={concepto}
            />
          ))}
        </>
      );
    }
  }

  const ajustarFechaFebrero = (fechaBase) => {
    const anio = fechaBase.year();
    const mes = fechaBase.month(); // Enero = 0, Febrero = 1
    const dia = fechaBase.date();
    if (mes === 1) {
      if (dia === 28) return moment(`${anio}-03-02`);
      if (dia === 29) return moment(`${anio}-03-01`);
    }

    // Para otros meses, usar el día 30 (aunque el mes no lo tenga)
    const fecha30 = moment(fechaBase).date(30);
    return fecha30;
  };



  const actualizarFechas = () => {
    let copiaConceptos = [...conceptos];
    let isMatriculaPlan = false;


    //Verificar si es un plan con matrícula
    if (copiaConceptos.length > 0) {
      isMatriculaPlan = copiaConceptos[0].id_tp_concepto == 1;
    }

    let mes_adicional = null;

    let nombre_concepto = '';

        if(modalidad == 1 )
          nombre_concepto = isMatriculaPlan ? `MENSUALIDAD ${num_romanos[conceptos.length - 1]}` : `MENSUALIDAD ${num_romanos[conceptos.length]}`;
        else if (modalidad == 3){
          nombre_concepto = isMatriculaPlan ? `CUOTA ${num_romanos[conceptos.length - 1]}` : `CUOTA ${num_romanos[conceptos.length]}`;
        }

       mes_adicional = {
        monto: 0,
        nombre_concepto: nombre_concepto,
        fecha_limite: null,
        id_tp_concepto: 2,
        orden: conceptos.length + 1
      }

      let dia = 0;
      //let prueba = '2025-08-31'; // o cualquier fecha válida en formato ISO
      let fechaActual = moment(fecha_inicio_p);
      let fecha_inicio = moment(fecha_inicio_p);
      let fechaStandar = moment(fechaActual).add(1, 'month');
      ////console.log(fechaActual,fecha_inicio)

      copiaConceptos.forEach((concepto, i) => {
        /*//console.log('mismo mes',fechaActual.format("M")===fecha_inicio.format("M"))
         //console.log('mismi año',fechaActual.format("YYYY")===fecha_inicio.format("YYYY"))*/
        if ((modalidad == 1 || modalidad == 3) && fechaActual.format("YYYY") === fecha_inicio.format("YYYY")) {
          ////console.log('mismo mes',fechaActual.format("M")===fecha_inicio.format("M"))
          // //console.log('mismi año',fechaActual.format("YYYY")===fecha_inicio.format("YYYY"))

          if ((i === 1 && !isMatriculaPlan) || (i === 2 && isMatriculaPlan))//aca solo entra mensualidad 2
          {
            mes_adicional.monto = 0;
            let fecha_second = new Date(`${fechaActual.format("YYYY")}-${fechaActual.format("MM")}-30 00:00:00`)
            let daysDiff = moment(fecha_second).diff(moment(fecha_inicio), 'days')
            //console.log(concepto.monto)
            let fraccion = parseFloat(parseInt(concepto.monto) / 30).toFixed(0);
            let monto_f = Number((fraccion * daysDiff).toFixed(2));
            if(monto_f>0){
              mes_adicional.monto = concepto.monto - monto_f
              concepto.monto_aux = monto_f;
            }
            let fechaAjustada = ajustarFechaFebrero(moment(fechaStandar));
            
            concepto.fecha_limite = fechaAjustada.format('YYYY-MM-DD');
            fechaStandar = moment(fechaStandar).add(1, 'month');
            // concepto.monto=concepto.monto - mes_adicional.monto;
          }
          else  // matricula o mensualidad 1 como orden 0
          {
            if (i == 0 || i == 1) {
              if (isMatriculaPlan) {
                concepto.fecha_limite = moment(fecha_inicio).format('YYYY-MM-DD');
              } else {
                if (i == 0) {
                  concepto.fecha_limite = moment(fecha_inicio).format('YYYY-MM-DD');
                }
              }
            } else {
              let fechaAjustada = ajustarFechaFebrero(moment(fechaStandar));
              concepto.fecha_limite = fechaAjustada.format('YYYY-MM-DD');
              fechaStandar = moment(fechaStandar).add(1, 'month');
            }
          }
        }
        else {
          let fechaAjustada = moment(fecha_inicio_p);
          console.log("Fecha ajustada",fechaAjustada)
          concepto.fecha_limite = fechaAjustada.format('YYYY-MM-DD');
          fechaStandar = moment(fechaStandar).add(1, 'month');
        }

      });

      if ((modalidad == 1 || modalidad == 3) && mes_adicional.monto) {
        ////console.log(mes_adicional)
        let fechaAjustada = ajustarFechaFebrero(moment(fechaStandar));
        mes_adicional.fecha_limite = fechaAjustada.format('YYYY-MM-DD');
        copiaConceptos = [...copiaConceptos, mes_adicional]
      }


    setConceptosFinales(copiaConceptos);
  }

  useEffect(() => {
    if (planes.length > 0 && !discente_trabajador) {
      setModalidad(planes[0].id_tp_modalidad);
    } else {
      setModalidad(id_tp_modalidad);
    }
  }, [plan]);

  useEffect(() => {
    if (modalidad !== null) {
      actualizarFechas();
    }
  }, [modalidad]);


  return (
    <div className="ContenidoPlan mt-3">
      {mostarItems()}
    </div>
  );
}

export default ContenidoPlan;